var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M216,158c-21.3-17.9-21.2-70.7-21.2-71.2c0-39.9-32.6-55.4-42.4-59.1C149.3,17.2,139.5,10,128.1,10c-11.3,0-21.1,7.2-24.2,17.5C61.7,42.8,61.3,86.3,61.3,86.8c0,54.9-20.1,70.8-20.6,71.1c-13.1,11.2-13.8,26.7-13.8,28.1c2.5,17.7,14.2,24,24.3,24l152.1,0c7.7,0,13.9-2.2,18.5-6.7c7.2-7.1,7.2-17,7.2-17.4C229.1,168,216.3,158.2,216,158L216,158z M215,196.8c-2.6,2.6-6.5,3.9-11.6,3.9l-151.5,0l-0.6,4.6v-4.6c-3.8,0-12.7-1.6-14.7-15.2c0-0.1,0.6-12.2,10.2-20.5c1-0.7,24.1-18.2,24.1-78.3c0-0.4,0.4-39,38.2-51.3c1.9-0.4,3.3-1.9,3.6-3.7c1.3-7.2,7.7-12.5,15.4-12.5c7.7,0,14.1,5.3,15.4,12.6c0.3,1.7,1.6,3.1,3.3,3.6c1.6,0.5,38.3,12.1,38.3,51.2c0,2.4-0.1,57.5,24.7,78.4c0.4,0.3,9.6,7.5,9.6,20.8C219.4,186,219.4,192.6,215,196.8L215,196.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M163.3,215.3c-2.3-0.8-4.7,0.4-5.5,2.8c-3.5,10.9-15.8,18.6-29.8,18.6c-14,0-26.3-7.6-29.8-18.5c-0.8-2.4-3.2-3.6-5.5-2.8c-2.3,0.8-3.4,3.5-2.6,5.9c4.7,14.6,20.3,24.7,38,24.7c17.7,0,33.2-10.2,38-24.8C166.7,218.8,165.6,216.2,163.3,215.3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAlarm);
export default __webpack_public_path__ + "static/media/ico_alarm.fc7057798f0ff05b057c276ec2c05202.svg";
export { ForwardRef as ReactComponent };